import axios from 'axios';
import {apiService} from "../../services/api.service";
import {extractData, handleResponse} from "../../helpers/apiResponseHelper";

export const BookingsService = {
    getBookingData: getBookingData
};

async function getBookingData(customerId: number | null) {
    if (customerId == null) {
        return [];
    }

    return axios.get(apiService.getApiUrl() + '/booking/' + customerId)
        .then(handleResponse).then(extractData);
}
